import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { VESTI } from '../data/vesti';
import Contact from '../containers/Contact/Contact';
import Footer from '../containers/Footer/Footer';
import '../containers/Vesti/vesti.css';

const Vesti = () => {
  const { t } = useTranslation('global');

  return (
    <>
      <section className="vesti-page">
        <p className="vesti-page__intro">BeoMedica</p>
        <h1 className="vesti-page__title">{t('vesti.title')}</h1>
        <div className="vesti-list">
          {VESTI.map((vest) => {
            const item = t(`vesti.items.${vest.slug}`, { returnObjects: true });
            return (
              <Link
                key={vest.slug}
                to={`/vesti/${vest.slug}`}
                className="vesti-card"
              >
                <div className="vesti-card__content">
                  <h2 className="vesti-card__title">{item.title}</h2>
                  <p className="vesti-card__teaser">{item.teaser}</p>
                  <span className="vesti-card__more">{t('vesti.read_more')}</span>
                </div>
                <div className="vesti-card__media">
                  <img src={vest.imageList} alt={item.title} />
                </div>
              </Link>
            );
          })}
        </div>
      </section>
      <Contact />
      <Footer />
    </>
  );
};

export default Vesti;
